$(document).ready(function(){

    // Filter Dropdowns on collection page
  
    $('.filter_wrapper .filter_title').click(function(){
        $(this).next().slideToggle().toggleClass('cstm-show');
        $(this).toggleClass('cstm-open');
    });

    // Product image change on click relevant swatch of product grid
  
    $(document).on('click', '.grid-view-item  .variant-image', function(){
        $(this).closest('.pro-var-col').find('img').removeClass('selected');
        var source = $(this).find('img').addClass('selected').attr('data-src');
        $(this).closest('.pro-var-col').siblings('.product-image-main').find('img').attr('srcset',source);
    });

    // All product images change on clicking relevant swatch on product page

    $('.product-form__controls-group .variant-image').click(function(){
      var variant = $(this).attr('data-value-color');

//       var variantQTY = $(this).attr('data-item-qty');

//       if ( variantQTY > 1 ) {
//         $(".stock-stat").text(" In Stock ")      
//       } else {
//         $(".stock-stat").text(" Re-Stocking Soon ");
//       }      

      var className = 'filter-'+variant;
      $(".product-single__thumbnails .slick-arrow").hide();
      if($('.thumbnails-wrapper .product-single__thumbnails-item').hasClass(className)){
        $('.thumbnails-wrapper .product-single__thumbnails-item').hide();
        $('.thumbnails-wrapper .'+className).show(); 
      }
    });

    // Remove Slick Vertical class on product page of mobile view
  
    if($(window).width() < 768){
        setTimeout(() => {
            $('.product-single__thumbnails').removeClass('.slick-vertical');
        }, 1000); 
    }

    var modalTrigger = $('[data-role=modal-trigger]');
    var modal = $('.cstm-modal');
    var modalContent = $(".cstm-modal .cstm-modal-content");
    
    modalTrigger.click(function() {
        var getModalId = $(this).attr('modal-target');
        $(getModalId).css('display', 'flex'); 
        $('body').css('overflow', 'hidden');
    })
    
    $('[modal-close]').click(function() {
        $(modal).css('display', 'none');
        $('body').css('overflow', 'visible');
    })
    
// -     $(modal).mouseup(e => {
//         if (!modalContent.is(e.target) && modalContent.has(e.target).length === 0)
//         {
//             $(modal).css('display', 'none');
//             $('body').css('overflow', 'visible');
//         }
//     });
   
  // dropdown cart

    $('.site-header__cart').click(function(e){
        e.preventDefault();
        $('html').addClass('cart-show');
        $('body').css('overflow','hidden');
    });
    $('.close-cart').click(function(e){
        e.preventDefault();
        $('html').removeClass('cart-show');
        $('body').css('overflow','auto');
    }); 

    // dropdown customer

    $('.site-header__account').click(function(e){
        e.preventDefault();
        $('html').addClass('customer-show');
        $('body').css('overflow','hidden');
    });
    $('.close-customer').click(function(e){
        e.preventDefault();
        $('html').removeClass('customer-show');
        $('body').css('overflow','auto');  
    });

    //   if cart has no item on load

    $(window).on('load' , function(){
        if($('#dropdown-cart .mini-products-list').children().length == 0){
            $('#dropdown-cart .has-items').hide();
        }
    });

    // Clickable megamenu links

    $('.site-nav__link--button, .mobile-nav-link').click(function(e){
        window.location.href = $(this).attr('data-link');
        $(this).closest('.js-toggle-submenu').attr('data-target','');
    });

    // Homepage Collections section on mobile

    if($(window).width() < 768){
        $('.home-cat-item').click(function(){
            $(this).find('.menu-box').css('visibility','visible');
        });
    }

    // Collection page Sidebar sticky on scroll
//     if($(window).width() > 768){ 
//         // var threshold = $('#MainContent').offset().top;
//         $(window).on('scroll' , function(){
//             if($(window).scrollTop() > 300){ 
//                 $('.collection-wrapper .sidebar').addClass('sidebar-sticky');
//                 $('.collection-wrapper .medium-up--three-quarters').css('float' , 'right');
//             }else{
//                 $('.collection-wrapper .sidebar').removeClass('sidebar-sticky');
//                 $('.collection-wrapper .medium-up--three-quarters').css('float' , 'left');
//             }
//             // if($(window).scrollTop() > threshold){
//             //     $('.collection-wrapper .sidebar').removeClass('sidebar-sticky');
//             //     $('.collection-wrapper .medium-up--three-quarters').css('float' , 'left');
//             // }else{
//             //     $('.collection-wrapper .sidebar').addClass('sidebar-sticky');
//             //     $('.collection-wrapper .medium-up--three-quarters').css('float' , 'right');
//             // }
//         });
//     }


	
// Product Variant Swatches Sold out Functionality on product page

//   var size, match, color;
//   color = $('.cstm-color-variant:checked').val();
//   $('.var-size').removeClass('sold-out');
//   $('.swatch-element').each(function(){
//     if($(this).hasClass('active')){
//     	size = $(this).attr('data-size');
//     	color = $(this).attr('data-color');
//     	 $('.cstm-color-variant').each(function(){
//           if(color === $(this).val()){
//               $(this).attr('checked', 'true');
//           }
//       	});
//        $('.cstm-size-variant').each(function(){
//           if(size === $(this).val()){
//               $(this).attr('checked', 'true');
//           }
//         });
//     }
//     if($(this).hasClass('soldout') && color === $(this).attr('data-color')){
//       	size = $(this).attr('data-size');
//       $('.cstm-color-variant:checked').closest('.product-form__controls-group').find('.var-size').each(function(){
//         if(size === $(this).html()){
//         	$(this).addClass('sold-out');
//         }
//       });
//     }
//   });
//   $('.cstm-color-variant').on('click' , function(){
//       color = $('.cstm-color-variant:checked').val();
//       $('.var-size').removeClass('sold-out');
//       $('.swatch-element').each(function(){
//         if($(this).hasClass('soldout') && color === $(this).attr('data-color')){
//             size = $(this).attr('data-size');
//           $('.cstm-color-variant:checked').closest('.product-form__controls-group').find('.var-size').each(function(){
//             if(size === $(this).html()){
//                 $(this).addClass('sold-out');
//             }
//           });
//         }
//       });
//     });

});

 $(document).ready(function () {
   
//     console.log('JJ/MAR Fix Swatchs');

    //     Uncheck All Color Swatch (Checkall due to error)....
    $('.selector-wrapper .cstm-color-variant').prop('checked', false);



    var activeVariantID = $('#ProductSelect-product-template').val();
   
//     console.log(activeVariantID);

    //     Check First Available Color & Size Swatch on Load time......

    $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').find('label').removeClass('sold-out');
    $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').hide();

    var activeVariantEl;

    $('.product-grid-variants.swatch > div').each(function () {
        let getID = $(this).attr('data-id');
        let availableSwacth = $(this).attr('data-available');
        if (activeVariantID === getID) {
            let getDummySize = $(this).attr('data-size');
            let getDummyColor = $(this).attr('data-color');

            activeVariantEl = getDummyColor.toLowerCase();

            $('.selector-wrapper .cstm-color-variant').each(function () {
                if ($(this).val() == getDummyColor) {
                    $(this).prop('checked', true);
                }
            });

            $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').each(function () {
                if ($(this).attr('data-swatch-size') == getDummySize) {
//                     $(this).find('.cstm-size-variant').attr('checked', true);
                    $(this).find('.cstm-size-variant').trigger("click");
                }
            });
        }
    });

    $('.product-grid-variants.swatch > div').each(function () {
        let getDummyColor = $(this).attr('data-color').toLowerCase();
        let getDummySize = $(this).attr('data-size');
        let availableSwacth = $(this).attr('data-available');

        if (activeVariantEl == getDummyColor) {
//             console.log(getDummyColor)
            $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').each(function () {
                if ($(this).attr('data-swatch-size') == getDummySize) {

                    if (availableSwacth === 'false') {
                        $(this).find('label').addClass('sold-out');
                    }

                }
            });
        }
    });

//     console.log(activeVariantEl);

    checkAvailableSize(activeVariantEl);

    //     Filter Sizes according to the Color [On Change Swatch]
    $('.selector-wrapper .cstm-color-variant').change(function () {

        let getCheckColor = $('.selector-wrapper .cstm-color-variant:checked').val().toLowerCase();

        checkAvailableSize(getCheckColor);
        selectFirstAvailable(getCheckColor);

    })

    function checkAvailableSize(getColorSwatch) {
//         console.log(getColorSwatch);
//         console.log('----');
        $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').hide()

        $('.product-grid-variants.swatch > div').each(function () {
            let getDummySwatchSize = $(this).attr('data-size');
            let getDummySwatchColor = $(this).attr('data-color').toLowerCase();

            if (getColorSwatch === getDummySwatchColor) {

                $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').each(function () {
                    if ($(this).attr('data-swatch-size') === getDummySwatchSize) {
                        $(this).show();
                    }

                })
            }
        });

    }

    function selectFirstAvailable(getColor) {
        var findFirstAvailable = true;

//         console.log("Select First Available");
      
        $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').find('label').removeClass('sold-out');

        $('.product-grid-variants.swatch > div').each(function () {
            let availableSwacth = $(this).attr('data-available');
            let getDummySwatchSize = $(this).attr('data-size');
            let getDummySwatchColor = $(this).attr('data-color').toLowerCase();


            if (getColor === getDummySwatchColor) {

                if (availableSwacth === 'false') {
                    $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').each(function () {
                        if ($(this).attr('data-swatch-size') === getDummySwatchSize) {
                            $(this).find('label').addClass('sold-out');
                        }
                    });
                }


                if (availableSwacth === 'true') {
                    
                    if (findFirstAvailable) {
                        $('.selector-wrapper .swatch-size-wrap-all .swatch-wrap-size').each(function () {

                            if ($(this).attr('data-swatch-size') === getDummySwatchSize) {
                                //                   $(this).find('input').prop('checked', true);
                                $(this).find('label').trigger('click');
                                findFirstAvailable = false;
//                                 console.log(this);

                            }

                        });
                    }
                }

            }

        });
    }
});

 

// <------------ Divider ----------->


 